export enum PilotageStatusCodes {
    Moored = 'P',
    Unmoored = 'O',
    Move = 'R'
}
